package com.crowpay.extensions

import com.lightningkite.kiteui.ViewWrapper
import com.lightningkite.kiteui.models.Dimension
import com.lightningkite.kiteui.views.ViewModifierDsl3
import com.lightningkite.kiteui.views.ViewWriter
import com.lightningkite.kiteui.views.tweakTheme

@ViewModifierDsl3
fun ViewWriter.withSpacing(value: Dimension): ViewWrapper = tweakTheme { it.copy(spacing = value) }